module.exports = __webpack_public_path__ + "img/consult_info13.4ee3497e.png";